import React from 'react';
import PropTypes from 'prop-types';
import isHotkey from 'is-hotkey';

export { MdFormatBold as BoldIcon } from 'react-icons/md';

export const BoldMark = ({ attributes, children }) => (
  <span className="boldMark" {...attributes}>{children}</span>
);

export const BOLD_MARK_TYPE = 'bold';

BoldMark.propTypes = {
  children: PropTypes.node,
  attributes: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

const boldPlugin = () => ({
  onKeyDown: (event, editor, next) => {
    if (isHotkey('mod+b', event)) {
      event.preventDefault();

      return editor.toggleMark(BOLD_MARK_TYPE);
    }
    next();
  },
  renderMark: (props, editor, next) => {
    if (props.mark.type === BOLD_MARK_TYPE) {
      return <BoldMark {...props} />;
    }
    return next();
  },
  commands: {
    toggleBold: editor => editor.toggleMark(BOLD_MARK_TYPE),
  },
  serialize: (node, children) => {
    if (node.type === BOLD_MARK_TYPE) {
      return <strong>{children}</strong>;
    }
  },
});

export default boldPlugin;
